import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/non-transferables`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  readById({commit}, payload: {id: number}) {
    return axiosInstance.get(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
  updateById({commit}, payload: {id: number, data: {
      name: string,
    }}) {
    return axiosInstance.put(`${baseUrl}/${payload.id}`, payload.data)
      .then((data) => data.data);
  },
  openDoor({commit}, payload: { id: number }) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/open-door`)
      .then((data) => data.data);
  },
  addGuests({commit}, payload: {
    id: number,
    userGroups: any[],
    userGroupsIds: number[],
    userGroupsData: any[],
    users: any[],
    invitation: object,
  }) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/guests`, {
      userGroups: payload.userGroups,
      userGroupsIds: payload.userGroupsIds,
      userGroupsData: payload.userGroupsData,
      users: payload.users,
      invitation: payload.invitation,
    }).then((data) => data.data);
  },
  getGuestsSoloById({commit}, payload: { id: number, pagination: any }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/guests`, {
      params: payload.pagination,
    }).then((data) => data.data);
  },
  getGuestsGroupsById({commit}, payload: { id: number, pagination: any }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/guests-groups`, {
      params: payload.pagination,
    }).then((data) => data.data);
  },
  deleteById({commit}, payload: { id: number }) {
    return axiosInstance.delete(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
